/* ============
 * Getters for the shipping module
 * ============
 *
 * The getters that are available on the
 * shipping module.
 */

export default {};